import type { FaireProductEntity } from "../../entity_types/product";

export const p_mq9jk74vhh: FaireProductEntity = {
  token: "p_mq9jk74vhh",
  type: "product",
  name: "Triple Puka Shell Hoops",
  brandName: "Salty But Sweet",
  imageUrl:
    "https://cdn.faire.com/fastly/c49ad1365e377733a663b93ac60bddf3682b01d7e2cd9ebb617bec7ec36b1240.jpeg",
  priceDollars: 16.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/ea1637126b5d5ec8bedf3025ae1617817e50b3281d8c8e2ef557fc783b8ba82c.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
